<template>
  <div
    class="lineCharts"
    :id="'lineCharts' + randomNumber"
  ></div>
</template>

<script>
export default {
  name: "LineCharts",
  props: {
    xAxisData: Array,
    yAxisData: Array,
    yUnitType: String
  },
  data() {
    return {
      randomNumber: Date.now()
    }
  },
  methods: {
    // 展示折线图
    showCharts() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('lineCharts' + this.randomNumber));//也可以通过$refs.newCharts的方式去获取到dom实例。
      // 绘制图表
      myChart.setOption({
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.xAxisData,
          axisLabel: {
            color: '#fff'
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false // 不显示网格线
          },
          axisLabel: {
            color: '#fff',
            formatter: (value, index) => {
              if (this.yUnitType === 'k') {
                return `${(value / 1000).toFixed(0)}k`
              }
              return value
            }
          },
          axisLine: {
            show: true
          }
        },
        series: [
          {
            data: this.handleYAxisDataMax(this.yAxisData),
            type: 'line',
            smooth: true,
            areaStyle: {
              color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0, color: '#40CFFF' // 0% 处的颜色
              }, {
                offset: 1, color: 'transparent' // 100% 处的颜色
              }]
              ),
            },
            itemStyle: {
              color: '#8cd5c2', //改变折线点的颜色
              lineStyle: {
                color: '#8cd5c2' //改变折线颜色
              }
            },
          },
        ],
        grid: {
          x: 40,
          y: 20,
          x2: 10,
          y2: 30
        },
      }, true)
    },
    handleYAxisDataMax(data) {
      let result = []
      let max = 0
      let size = 0
      for (let ele in data) {
        result.push({
          value: data[ele]
        })
        if (data[ele] > max) {
          max = data[ele]
          size = ele
        }
      }
      result[size] = {
        value: result[size].value,
        label: {
          show: true,
          color: '#75f8fd'
        }
      }
      return result
    }
  },
  watch: {
    'yAxisData': function(val) {
      this.showCharts()
    }
  },
}
</script>

<style scoped>
.lineCharts {
  width: 330px;
  height: 145px;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.1);
}
</style>
